import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SignIn from './component/SigninPage/Signin';
import SignUp from './component/SignUp/SignUp';
import ForgotPassword from './component/ForgotPassword/ForgotPassword';
import HomeScreen from './component/HomeScreen/HomeScreen';
import DataSet from './component/DataSet/DataSet';
import PrivateSet from './component/PrivateSet/PrivateSet';
import SharedSet from './component/SharedSet/SharedSet';
import FileUpload from './component/FileUpload/FileUpload';
import FileUpdate from './component/FileUpdate/FileUpdate';
import DetailsPageRoute from './component/DetailsPageRoute/DetailsPageRoute';
import ConfirmPass from './component/ConfirmPass/ConfirmPass';
import Notes from './component/Notes/Notes';
import { GlobalUrl, apiBasePath } from './component/Global';
import NotesDetails from './component/Notes/Notesdetails';
import TaskIdPage from './component/FileUpload/taskIdPage';
import PrivateRoute from './component/PrivateRoute'; // Import PrivateRoute
import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import { Helmet } from 'react-helmet';
import PrivacyPolicy from './component/TermsPrivacy/PrivacyPolicy'
import TermsOfService from './component/TermsPrivacy/TermsOfService'

SuperTokens.init({
  appInfo: {
    apiDomain: GlobalUrl,
    apiBasePath: apiBasePath,
    appName: "Ignite",
  },
  recipeList: [
    Session.init(),
    EmailPassword.init(),
  ],
});

const TitleWrapper = ({ title, children }) => {
  return (
    <>
      <Helmet>
        <title>{title} | DataSpeak</title>
      </Helmet>
      {children}
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
      <Route path="/signin" element={
          <TitleWrapper title="Sign In">
            <SignIn />
          </TitleWrapper>
        } />
        <Route path="/signup" element={
          <TitleWrapper title="Sign Up">
            <SignUp />
          </TitleWrapper>
        } />
        <Route path="/forgotpassword" element={
          <TitleWrapper title="Forgot Password">
            <ForgotPassword />
          </TitleWrapper>
        } />
        <Route path="/account/reset-password" element={
          <TitleWrapper title="Reset Password">
            <ConfirmPass />
          </TitleWrapper>
        } />
        <Route path="/react" element={<Navigate to="/" />} />
        <Route path="/terms-of-service" element={
            <TitleWrapper title="Terms of Service">
              <TermsOfService />
            </TitleWrapper>
          } />
        <Route path="/privacy-policy" element={
          <TitleWrapper title="Privacy Policy">
            <PrivacyPolicy />
          </TitleWrapper>
        } />
        {/* Protect routes with PrivateRoute */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={
            <TitleWrapper title="Home">
              <HomeScreen />
            </TitleWrapper>
          } />
          <Route path="/dataset/list/public" element={
            <TitleWrapper title="Public Datasets">
              <DataSet />
            </TitleWrapper>
          } />
          <Route path="/dataset/notes" element={
            <TitleWrapper title="Notes">
              <Notes />
            </TitleWrapper>
          } />
          <Route path="/dataset/list/private" element={
            <TitleWrapper title="Private Datasets">
              <PrivateSet />
            </TitleWrapper>
          } />
          <Route path="/dataset/list/shared" element={
            <TitleWrapper title="shared Datasets">
              <SharedSet />
            </TitleWrapper>
          } />
          <Route path="/upload" element={
            <TitleWrapper title="Upload Files">
              <FileUpload />
            </TitleWrapper>
          } />
          <Route path="/update/:datasetId" element={
            <TitleWrapper title="Update Files">
              <FileUpdate />
            </TitleWrapper>
          } />
          <Route path="/collection/:dataset_name/:type" element={<DetailsPageRoute />} />
          <Route path="/dataset/notes/:id/:name" element={<NotesDetails />} />
          <Route path="/dataset/upload/:id" element={<TaskIdPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
